<template>
  <div id="app">
    <principal />
  </div>
</template>

<script>
import Principal from "./views/layouts/Principal.vue";

export default {
  name: "App",
  components: {
    Principal,
  },
};
</script>
<style>
.highlight {
  background-color: gold;
  border-radius: 4px;
}
</style>
